import React from 'react';
import LazyLoad from 'react-lazyload';
const img404  = 'https://cdn.arworld.art/FEassets/arframe-mobile/assets/images/404.png'
const nofount = () => {
  return (
    <div className="nofount">
      <LazyLoad>
        <img src={img404} alt="404 Not Found" style={{width:'100%',height:'100%'}}/>
      </LazyLoad>
    </div>
  );
}

export default nofount;
